// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"412":"5774750c","623":"f167c5e7","940":"ef6a5920"}[chunkId] + ".chunk.css";
};